export interface GsmSignalSummary {
  gsmSignalAverage: number | null;
  gsmSignalMin: number | null;
  gsmSignalMax: number | null;
  gsmSignalSampleCount: number;
}

export const normalizeGsmSignal = (value: Partial<GsmSignalSummary>): GsmSignalSummary => {
  const { gsmSignalAverage: average, gsmSignalMin: min, gsmSignalMax: max, gsmSignalSampleCount: count } = value;
  const validSignal = (signal: unknown): signal is number =>
    typeof signal === 'number' && Number.isFinite(signal) && signal >= 0 && signal <= 255;

  if (validSignal(average) && validSignal(min) && validSignal(max) &&
      min <= average && average <= max && typeof count === 'number' && Number.isSafeInteger(count) && count > 0) {
    return { gsmSignalAverage: average, gsmSignalMin: min, gsmSignalMax: max, gsmSignalSampleCount: count };
  }

  return { gsmSignalAverage: null, gsmSignalMin: null, gsmSignalMax: null, gsmSignalSampleCount: 0 };
};
